import React from "react";
import { Sun, Moon } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../hooks/useTheme";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Activar modo claro" : "Activar modo oscuro"}
      data-testid="theme-toggle"
      className="relative inline-flex h-10 w-10 sm:w-[68px] items-center justify-center sm:justify-start rounded-full border overflow-hidden"
      style={{
        borderColor: "var(--osx-border-strong)",
        background: "var(--osx-surface-2)",
        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
        transition: "background-color 0.25s ease, border-color 0.25s ease",
      }}
    >
      <span
        className="hidden sm:block absolute top-1 left-1 h-8 w-8 rounded-full"
        style={{
          background:
            "linear-gradient(135deg, var(--osx-brand-600), var(--osx-accent-cyan))",
          boxShadow: "0 4px 12px rgba(2,132,199,0.35)",
          transform: isDark ? "translateX(28px)" : "translateX(0)",
          transition: "transform 0.35s cubic-bezier(.22,.8,.25,1)",
        }}
        aria-hidden
      />
      <span className="relative z-10 flex w-full justify-between px-2 sm:px-1.5">
        <AnimatePresence mode="wait" initial={false}>
          {!isDark ? (
            <motion.span
              key="sun"
              initial={{ rotate: -60, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 60, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="inline-flex h-8 w-8 items-center justify-center text-white"
            >
              <Sun size={16} strokeWidth={2.4} />
            </motion.span>
          ) : (
            <span className="hidden sm:inline-flex h-8 w-8 items-center justify-center" style={{ color: "var(--osx-text-muted)" }}>
              <Sun size={14} strokeWidth={2} />
            </span>
          )}
        </AnimatePresence>
        <AnimatePresence mode="wait" initial={false}>
          {isDark ? (
            <motion.span
              key="moon"
              initial={{ rotate: 60, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -60, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="inline-flex h-8 w-8 items-center justify-center text-white"
            >
              <Moon size={16} strokeWidth={2.4} />
            </motion.span>
          ) : (
            <span className="hidden sm:inline-flex h-8 w-8 items-center justify-center" style={{ color: "var(--osx-text-muted)" }}>
              <Moon size={14} strokeWidth={2} />
            </span>
          )}
        </AnimatePresence>
      </span>
    </button>
  );
};
